var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { staticClass: "stretch-grid no-footer" },
    [
      _vm.open
        ? _c("UserDetailsModal", { attrs: { module: _vm.module } })
        : _vm._e(),
      _c("Grid", {
        staticClass: "fit",
        attrs: {
          id: "instructorApprovalsGrid",
          expandable: true,
          module: _vm.module,
          data: _vm.approvalList,
          columns: _vm.columnOptions,
          loading: _vm.loadingData,
          filterable: _vm.filterable,
          pagination: _vm.paginationOptions,
          onLaunch: _vm.selectInstructorUser,
          onRequest: _vm.onFetch,
          onExport: _vm.fetchInstructors
        },
        scopedSlots: _vm._u([
          {
            key: "col-item-status",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "label small",
                    class: {
                      blue:
                        props.value == "SUBMITTED" ||
                        props.value == "RESUBMITTED",
                      green: props.value == "APPROVED",
                      red: props.value == "REJECTED",
                      yellow: props.value == "EXPIRED",
                      grey: props.value == "NOT SUBMITTED"
                    },
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "10px",
                      "border-radius": "30px"
                    }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(props.value) +
                        "\n            "
                    )
                  ]
                )
              ]
            }
          },
          {
            key: "col-item-date_created",
            fn: function(props) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.moment(props.value).format("MMMM Do, YYYY h:mm A")
                    ) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "col-item-expand",
            fn: function(props) {
              return [
                _c(
                  "div",
                  { staticClass: "sessions-table" },
                  [
                    _c("div", { staticClass: "sl-row table-head" }, [
                      _c("div", { staticClass: "sl-col-9" }, [
                        _vm._v("\n            Approval History\n          ")
                      ])
                    ]),
                    _c("div", { staticClass: "sl-row table-columns" }, [
                      _c("div", { staticClass: "sl-col-3" }, [
                        _vm._v("\n            Date Updated\n          ")
                      ]),
                      _c("div", { staticClass: "sl-col-2" }, [
                        _vm._v("\n            Status \n          ")
                      ]),
                      _c("div", { staticClass: "sl-col-4" }, [
                        _vm._v("\n            Notes\n          ")
                      ])
                    ]),
                    _vm._l(props.props.row.HISTORY, function(approval) {
                      return _c(
                        "div",
                        {
                          key: approval.INSTRUCTOR_APPROVAL_ID,
                          staticClass: "sl-row"
                        },
                        [
                          _c("div", { staticClass: "sl-col-3" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm
                                    .moment(approval.DATE_CREATED)
                                    .format("MMMM Do, YYYY h:mm A")
                                ) +
                                "\n          "
                            )
                          ]),
                          _c("div", { staticClass: "sl-col-2" }, [
                            _c(
                              "div",
                              {
                                staticClass: "label small",
                                class: {
                                  blue:
                                    approval.LK_INSTRUCTOR_APPROVAL_STATUS_ID ==
                                      1 ||
                                    approval.LK_INSTRUCTOR_APPROVAL_STATUS_ID ==
                                      5,
                                  grey:
                                    approval.LK_INSTRUCTOR_APPROVAL_STATUS_ID ==
                                    6,
                                  yellow:
                                    approval.LK_INSTRUCTOR_APPROVAL_STATUS_ID ==
                                    4,
                                  green:
                                    approval.LK_INSTRUCTOR_APPROVAL_STATUS_ID ==
                                    2,
                                  red:
                                    approval.LK_INSTRUCTOR_APPROVAL_STATUS_ID ==
                                    3
                                },
                                staticStyle: {
                                  display: "inline-block",
                                  "margin-left": "10px",
                                  "border-radius": "30px"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.lookupApprovalStatus(
                                        approval.LK_INSTRUCTOR_APPROVAL_STATUS_ID
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          ]),
                          _c("div", { staticClass: "sl-col-4" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(approval.NOTES) +
                                "\n          "
                            )
                          ])
                        ]
                      )
                    })
                  ],
                  2
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }